import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-meridians",
  "use": "icon-meridians-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-meridians\"><path d=\"M38.912 789.504s175.104 80.896 354.304-15.36S777.216 584.704 986.112 870.4c0 0-175.104-80.896-354.304 15.36s-385.024 190.464-592.896-96.256zM514.048 430.08l-31.744 43.008 8.192-453.632 34.816 342.016 47.104-75.776-45.056 393.216L514.048 430.08z\" p-id=\"13739\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/meridians.svg
// module id = OlgF
// module chunks = 79